export enum ActionPlanVisibility {
  Internal = 'internal',
  Shared = 'shared',
}

export enum ActionPlanTaskStatus {
  Completed = 'completed',
  Pending = 'pending',
}

export enum ActionPlanTaskReorderPosition {
  Above = 'above',
  Below = 'below',
}
